import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Table from "../../Shared/Table";
import LoadingScreen from "../../Shared/LoadingScreen";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCcVisa, faCcMastercard, faCcDiscover, faCcAmex } from "@fortawesome/free-brands-svg-icons";
import { PrimaryButton } from "../../Shared/Buttons";
import ModalComp from "../../Shared/ModalComp";
import GetPayments from "../../Store/Actions/GetPayment-Action";
import { PaymentAction } from "../../Store/Reducers/Payment-reducer";

const PaymentComp = () => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState([]);
  const { data, loading, isLoaded, lastEvaluatedkey, searchData, showSearch } = useSelector((state) => state.Payment);
  const [load, setLoad] = useState(false);
  useEffect(() => {
    dispatch(PaymentAction.setShowSearch(false));
    if (!isLoaded) {
      dispatch(GetPayments(lastEvaluatedkey));
      dispatch(PaymentAction.setIsLoaded(true));
    }
  }, [isLoaded, lastEvaluatedkey, dispatch]);

  // Open modal and fetch data
  const openModal = async (restaurantId) => {
    console.log("Model Clicked", restaurantId);
    console.log("Modal isOpen State:", isModalOpen);
    try {
      setLoad(true);
      const res = await axios.get(`${process.env.REACT_APP_API_URL}payment-changes?restaurant_id=${restaurantId}`);
      console.log("Fetched Changes Data:", res.data.body);
      const parsedData = JSON.parse(res.data.body).data;
      console.log("Fetched Changes Data::", parsedData);
      setSelectedPayment(parsedData);
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error fetching payment changes:", error);
    } finally {
      setLoad(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedPayment([]);
  };

  // Format the table data
  const formatData = (data) => {
    console.log("Data:", data);
    return data?.map((item) => {
      const firstGateway = item?.gateway_info?.[0] || {};
      return {
        Restaurant_Name: item.name || "—",
        Email_ID: item.email_id || "—",
        Processor_Name: firstGateway.processor_name || "—",
        Gateway_UserName: firstGateway.user_name || "—",
        Gateway_Code: firstGateway.customer_code || "—",
        Cards_Accepted: formatCardIcons(item.cards_accepted),
        details: (
          <PrimaryButton size="small" style={{ width: "100px" }} handleClick={() => openModal(item.id)}>
            DETAILS
          </PrimaryButton>
        ),
      };
    });
  };

  // Format card icons
  const formatCardIcons = (cardData) => {
    console.log("Card Data---", cardData);
    if (!cardData || typeof cardData !== "object") return "—";
    const icons = [];
    if (cardData.visa) icons.push(<FontAwesomeIcon icon={faCcVisa} key="visa" style={{ fontSize: "20px", marginRight: "5px" }} />);
    if (cardData.mastercard) icons.push(<FontAwesomeIcon icon={faCcMastercard} key="mastercard" style={{ fontSize: "20px", marginRight: "5px" }} />);
    if (cardData.discover) icons.push(<FontAwesomeIcon icon={faCcDiscover} key="discover" style={{ fontSize: "20px", marginRight: "5px" }} />);
    if (cardData.american_express) icons.push(<FontAwesomeIcon icon={faCcAmex} key="amex" style={{ fontSize: "20px", marginRight: "5px" }} />);
    if (cardData.pay_by_cash) icons.push(<span key="cash" style={{ marginRight: "10px", fontWeight: "bold" }}>CASH</span>);
    if (cardData.pay_by_card) icons.push(<span key="card" style={{ marginRight: "10px", fontWeight: "bold" }}>CARD</span>);
    console.log("Payment Types:", cardData.payment_types);
    console.log("Pay by Cash:", cardData.pay_by_cash);
    console.log("Pay by Card:", cardData.pay_by_card);
    return icons.length > 0 ? icons : "No cards";
  };

  // Format changes data for modal table
  const formatChangesData = (changesData) => {
    console.log("Changes Data:", changesData);
    return changesData.flatMap((item) =>
      item.changes.map((change, index) => ({
        Email_ID: change.email,
        field: change.field || "—",
        oldValue: formatCardIcons(change.oldValue),
        newValue: formatCardIcons(change.newValue),
        timestamp: item.timestamp 
        ? new Date(item.timestamp).toLocaleString() 
        : "Invalid date",
      }))
    );
  };

  // Table columns
  const columns = [
    { name: "Restaurant_Name", label: "Restaurant Name" },
    { name: "Email_ID", label: "Email ID" },
    { name: "Processor_Name", label: "Gateway Name" },
    { name: "Gateway_UserName", label: "Gateway Username" },
    { name: "Gateway_Code", label: "Gateway Code" },
    { name: "Cards_Accepted", label: "Cards Accepted", options: { filter: false, sort: false, searchable: false } },
    { name: "details", label: "Details", options: { filter: false, sort: false, searchable: false } },
  ];

  // Changes table columns for modal
  const changesColumns = [
    {name: "Email_ID", label: "Email ID"},
    { name: "field", label: "Field Modified" },
    { name: "oldValue", label: "Old Value" },
    { name: "newValue", label: "New Value" },
    { name: "timestamp", label: "Timestamp" },
  ];

  return (
    <>
      {loading && <LoadingScreen loading={loading} />}
      <Table data={showSearch ? formatData(searchData) : formatData(data)} columns={columns} title="Payments" />
      {/* Modal for Payment Changes */}
      {/* {console.log("Selected Payments", selectedPayment, formatChangesData(selectedPayment), isModalOpen)} */}
      {load && <LoadingScreen loading={load} />}
      <ModalComp open={isModalOpen} handleClose={closeModal} title="Changes History">
        {console.log("Selected Payments", selectedPayment, formatChangesData(selectedPayment), isModalOpen)}
        <Table data={formatChangesData(selectedPayment)} columns={changesColumns} title="Payment Changes" />
      </ModalComp>
    </>
  );
};

export default PaymentComp;